module.exports = __webpack_public_path__ + "img/50.944b6c55.jpg";